import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-white text-gray-800 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-8 md:mb-12">
          <div>
            <h3 className="text-base md:text-lg font-bold mb-4 md:mb-6">{t('footer_about')}</h3>
            <ul className="space-y-2 md:space-y-3">
              <li><a href="#" className="text-sm text-gray-500 hover:text-gray-900 transition-colors cursor-pointer">{t('footer_our_story')}</a></li>
              <li><a href="#" className="text-sm text-gray-500 hover:text-gray-900 transition-colors cursor-pointer">{t('footer_team')}</a></li>
              <li><a href="#" className="text-sm text-gray-500 hover:text-gray-900 transition-colors cursor-pointer">{t('footer_values')}</a></li>
              <li><a href="#" className="text-sm text-gray-500 hover:text-gray-900 transition-colors cursor-pointer">{t('footer_work_with_us')}</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-base md:text-lg font-bold mb-4 md:mb-6">{t('footer_popular_dest')}</h3>
            <ul className="space-y-2 md:space-y-3">
              <li><a href="#" className="text-sm text-gray-500 hover:text-gray-900 transition-colors cursor-pointer">Torres del Paine</a></li>
              <li><a href="#" className="text-sm text-gray-500 hover:text-gray-900 transition-colors cursor-pointer">San Pedro de Atacama</a></li>
              <li><a href="#" className="text-sm text-gray-500 hover:text-gray-900 transition-colors cursor-pointer">Isla de Pascua</a></li>
              <li><a href="#" className="text-sm text-gray-500 hover:text-gray-900 transition-colors cursor-pointer">Valparaíso</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-base md:text-lg font-bold mb-4 md:mb-6">{t('footer_resources')}</h3>
            <ul className="space-y-2 md:space-y-3">
              <li><a href="#" className="text-sm text-gray-500 hover:text-gray-900 transition-colors cursor-pointer">{t('footer_travel_blog')}</a></li>
              <li><a href="#" className="text-sm text-gray-500 hover:text-gray-900 transition-colors cursor-pointer">{t('footer_destination_guides')}</a></li>
              <li><a href="#" className="text-sm text-gray-500 hover:text-gray-900 transition-colors cursor-pointer">{t('footer_travel_tips')}</a></li>
              <li><a href="#" className="text-sm text-gray-500 hover:text-gray-900 transition-colors cursor-pointer">{t('footer_faq')}</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-base md:text-lg font-bold mb-4 md:mb-6">{t('footer_contact')}</h3>
            <ul className="space-y-2 md:space-y-3">
              <li className="text-sm text-gray-500">Santiago, Chile</li>
              <li className="text-sm text-gray-500">+56 9 5331 8253</li>
              <li className="text-sm text-gray-500 break-words">contacto@galitravelchile.com</li>
              <li className="flex gap-3 mt-4">
                {[
                  { icon: 'instagram', url: 'https://www.instagram.com/galitravelchile/' },
                ].map(({ icon, url }) => (
                  <a key={icon} href={url} target="_blank" rel="noopener noreferrer nofollow"
                    className="w-9 h-9 bg-gray-100 rounded-full flex items-center justify-center hover:bg-gray-200 transition-colors cursor-pointer text-gray-600">
                    <i className={`ri-${icon}-fill`}></i>
                  </a>
                ))}
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-6 md:pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-3">
              <img
                src="https://static.readdy.ai/image/fdb1d692218b16774433254afb67402e/62228a1116343f550020e817b40b73a2.jpeg"
                alt="GaLi Travel Chile"
                className="h-8 md:h-10 w-auto object-contain"
              />
            </div>
            <p className="text-xs md:text-sm text-gray-400 text-center">{t('footer_rights')}</p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs md:text-sm text-gray-400 hover:text-gray-800 transition-colors cursor-pointer">{t('footer_terms')}</a>
              <span className="text-gray-300">|</span>
              <a href="#" className="text-xs md:text-sm text-gray-400 hover:text-gray-800 transition-colors cursor-pointer">{t('footer_privacy')}</a>
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-6 md:mt-8">
          <div className="px-4 py-2 bg-gray-100 rounded-lg">
            <span className="text-xs text-gray-500">{t('footer_cert_sernatur')}</span>
          </div>
          <div className="px-4 py-2 bg-gray-100 rounded-lg">
            <span className="text-xs text-gray-500">{t('footer_cert_safe')}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}